export default __webpack_public_path__ + "static/media/Logo.e8e421ba.svg";